import { render, staticRenderFns } from "./PriceListForm.vue?vue&type=template&id=6ef71fd8&scoped=true&"
import script from "./PriceListForm.vue?vue&type=script&lang=js&"
export * from "./PriceListForm.vue?vue&type=script&lang=js&"
import style0 from "./PriceListForm.vue?vue&type=style&index=0&id=6ef71fd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef71fd8",
  null
  
)

export default component.exports